import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { TopnavService } from './topnav.service';
import { NavService } from '../../header/nav/nav.service';
import { SharedService } from '../../common/shared.service';
import { Router, ActivatedRoute } from '@angular/router';

let num = 0;

export interface LangChangeEvent {
  lang: string;
  translations: any;
}

/**
 * Author: Sridhar Swaminathan
 *
 * Date Created: November 14th 2017
 *
 * Description: Component class for Header Top Navigation Menu
 **/
@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})

export class TopnavComponent implements OnInit, AfterViewInit, OnDestroy {
  public loginLink: string;
  translatedText: string;
  supportedLanguages: any[];
  colors: any[];
  selectedRow: Number;
  firstItem: boolean;
  minusBtn = false;
  plusBtn = false;
  admin: boolean;
  langId;
  defaultColors: any;
  defaultFonts: any;
  num: any = 0;
  imgSrc: string;

  private subscription: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  loading: boolean = false;
  fontTy(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  getThemeColors: any;
  getThemeFonts: any;

  @Input() edited = true;
  @Input() profileShow = true;
  @Input() sidenavShow = true;

  @Input() state:string;

  @Output() topNavClick = new EventEmitter();

  @Output() showProfile = new EventEmitter();

  @Output() showsidenav = new EventEmitter();

  private myflag: any;

  customFontType: any;

  constructor(private translate: TranslateService,
    private topnavservice: TopnavService,
    public sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    public navService: NavService) {
    translate.addLangs(['en', 'ms']);

    if(localStorage.getItem('langID') == "2"){
      translate.setDefaultLang('ms');
      translate.use('ms');
    }else{
      translate.setDefaultLang('en');
      translate.use('en');
    }

    if (translate.getDefaultLang() == 'ms') {
      this.currlang = 'English';
      this.currlangMOB = 'EN';
      this.langId = 2;
      this.loginLink = '../portal-protected/?language='+'EN';
      this.imgSrc = 'Logo_MyGovernment-BM.png';
    } else {
      this.currlang = 'Bahasa Melayu';
      this.currlangMOB = 'BM';
      this.langId = 1;
      this.loginLink = '../portal-protected/?language='+'MY';
      this.imgSrc = 'Logo_MyGovernment-EN.png';
    }

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      if (localStorage.getItem('customFontSize')) {
        let dynum = parseInt(localStorage.getItem('customFontSize'));
        this.sharedService.currFontNum.next(dynum);
        if (dynum < -2) {
          this.minusBtn = true;
          this.plusBtn = false;
        } else if (dynum > -2) {
          this.minusBtn = false;
          //this.plusBtn = true
        }

        if (dynum > 2) {
          this.plusBtn = true;
          this.minusBtn = false;
        } else if (dynum < 2) {
          this.plusBtn = false;
          //this.minusBtn = true
        }
      }

    });

    if(!localStorage.getItem('customFontSize')) {
      localStorage.setItem('customFontSize','0');
    }

    if(!localStorage.getItem('customFontType')) {
      localStorage.setItem('customFontType','Arial');
    }

    //alert(localStorage.getItem('themeColor'));
    // if(!localStorage.getItem('themeColor')) {
      localStorage.setItem('themeColor', '#2c2f6a');
      localStorage.setItem('themeIndex', '0');
      localStorage.setItem('themeName', 'index0');
    // }

    if (localStorage.getItem('customFontSize')) {
      this.num = parseInt(localStorage.getItem('customFontSize'));
    }

    this.route.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
      } else {
        this.myflag = null;
      }
    });

    this.sharedService.fontTypeData.subscribe((data)=>{
      this.customFontType = data;
    });

    this.sharedService.currFontNum.subscribe((data)=>{
      if (data == 0) {
        this.minusBtn = false;
        this.plusBtn = false;
      } else if (data < -2) {
        this.minusBtn = true;
        this.plusBtn = false;
      } else if (data > 2) {
        this.plusBtn = true;
        this.minusBtn = false;
      }
    });

  }

  isActive;

  currlang: string; // = this.currlang;
  currlangMOB: string; // = this.currlangMOB;


  ngOnInit() {

    //this.colors = this.topnavservice.getColors();
    this.loadFont();
    this.loadColor();
    // this.loadDefaultFonts();
    // this.loadDefaultColor();
    this.getLangID();

    this.getUserProfile();

    //

    if(this.currlang == 'English'){
      this.isActive = true;
    }else{
      this.isActive = false;
    }

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      //alert(this.translate.currentLang);
      const myLang = this.translate.currentLang;
      if (myLang === 'ms') {
        this.isActive = true;
        this.currlang = 'English';
        this.currlangMOB = 'EN';
        //this.translate.use('ms');
        this.langId = 2;
        this.loginLink = '../portal-protected/?language='+'MY';
      } else {
        this.isActive = false;
        this.currlang = 'Bahasa Melayu';
        this.currlangMOB = 'BM';
        this.langId = 1;
        //this.translate.use('en');
        this.loginLink = '../portal-protected/?language='+'EN';
      }
      localStorage.setItem('langID', this.langId);
      this.topnavservice.getEventLang();
    });
    this.showConfBar();

  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.navService.digitalTop) {
        this.loadCustomFontType();
        this.showConfBar();
      }
    }, 1000);

    this.sharedService.loadFontSizeData();
  }


  ngOnDestroy() {
    // this.subscriptionLang.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }



  loadFont(){
   this.subscription =  this.sharedService.getThemeFont().subscribe(
      data => {
        this.getThemeFonts = data;
        this.sharedService.themefontData.next(data);
      }, err => {

      })
  }


  getLangID(){
    if(!localStorage.getItem('langID')){
      localStorage.setItem('langID', this.langId);
    }
  }

  getUserProfile(){
    let getUsrID = localStorage.getItem('usrID');
    if(getUsrID){
      this.admin = true;
    }else{
      this.admin = false;
    }
  }

  loadDefaultFonts(){
    this.sharedService.getThemeFont().subscribe(
      data => {
        this.defaultFonts = data;
        data.filter(function(font){
          if(font.defaultFont == true){
            if (!localStorage.getItem('customFontType')) {
              $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', font.fontName);
              this.sharedService.setFontType(font.fontName);
            }
          }
        })
      }, err => {

      })
  }

  loadDefaultColor(){
    this.sharedService.getThemeColor().subscribe(
      data => {
        this.defaultColors = data;
        data.filter(function(color, index){
          if(color.defaultColor == true){
            if (!localStorage.getItem('themeColor')) {
              localStorage.setItem('themeColor', color.colorCode);
              localStorage.setItem('themeIndex', index);
              $('#confBar #themeContainer ul li.settingBtm input').removeClass('colorPaletteActive');
              $('#confBar #themeContainer ul li.settingBtm input:nth('+index+')').addClass('colorPaletteActive');
            }
          }
        })
      }, err => {

      })
  }


  toggle() {
    this.isActive = !this.isActive;
    if (this.isActive) {
      this.currlang = 'English';
      this.currlangMOB = 'EN';
      this.translate.use('ms');
      this.langId = 2;
      this.imgSrc = 'Logo_MyGovernment-EN.png';
    }
    else {
      this.currlang = 'Bahasa Melayu';
      this.currlangMOB = 'BM';
      this.langId = 1;
      this.imgSrc = 'Logo_MyGovernment-BM.png';
      this.translate.use('en');

      if (this.myflag) {
        let url = this.removeParam('language',this.router.url);
        this.router.navigateByUrl(url);
      }

    }
    localStorage.setItem('langID', this.langId);
    this.topnavservice.getEventLang();
    this.topnavservice.getFlagLang(true);
    this.topnavservice.getFlagLangApp(true);
  }

  removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

  loadColor(){
    this.sharedService.getThemeColor().subscribe(
      data => {
        this.getThemeColors = data;
        this.sharedService.themecolorData.next(data);
        //
      }, err => {

      })
  }




  showConfBar() {
    this.edited = !(this.edited);
    this.topNavClick.emit(this.edited);
    this.loadCustomFontType();
  }

  showProfileMenu(){
    //this.profileShow = !(this.profileShow);
    this.showProfile.emit(this.profileShow);
  }

  showSidenavMenu(){
    this.showsidenav.emit(this.sidenavShow);
  }

  langEventChange(data) {

  }

  setClickedColor(index, firstItem) {
    localStorage.setItem('themeColor', firstItem);
    localStorage.setItem('themeName', 'index'+index);
    $('#confBar #themeContainer ul li.settingBtm input').removeClass('colorPaletteActive');
    $('#confBar #themeContainer ul li.settingBtm input:nth('+index+')').addClass('colorPaletteActive');
    localStorage.setItem('themeIndex', index);
    this.selectedRow = index;
    this.firstItem = firstItem;

    this.sharedService.setBgColorData(firstItem);
  }

  loadCustomFontType(){
    if (localStorage.getItem('customFontType')) {
      $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', localStorage.getItem('customFontType'));
      $('#fontOptSideMenu2 option[value="' + localStorage.getItem('customFontType') + '"]').attr('selected', 'selected');
      $('#fontOptSideMenu2').val(localStorage.getItem('customFontType'));
      this.sharedService.setFontType(localStorage.getItem('customFontType'));
      this.customFontType = localStorage.getItem('customFontType');
    }
    if (localStorage.getItem('themeIndex')) {
      //$('#confBar #themeContainer ul li.settingBtm input').removeClass('colorPaletteActive');
      //$('#confBar #themeContainer ul li.settingBtm input:nth('+localStorage.getItem('themeIndex')+')').addClass('colorPaletteActive');
      //localStorage.setItem('themeIndex', localStorage.getItem('themeIndex'));
      setTimeout(() => {
        $('#confBar #themeContainer ul li.settingBtm input').removeClass('colorPaletteActive');
        $('#confBar #themeContainer ul li.settingBtm input:nth('+localStorage.getItem('themeIndex')+')').addClass('colorPaletteActive');
      }, 1000);
    }



    /*if (localStorage.getItem('customFontSize')) {
      let dynum = parseInt(localStorage.getItem('customFontSize'));
      $('.font-size-s').css('font-size', 14 + dynum + 'px');
      $('.font-size-m').css('font-size', 19 + dynum + 'px');
      $('.font-size-l').css('font-size', 23 + dynum + 'px');
      $('.mat-tab-label').css('font-size',14 + dynum + 'px');
      $('.no-styles').css('font-size',0.9 + dynum*0.1 + 'em');
      $('.mat-form-field-placeholder').css('font-size', 14 + dynum + 'px');
    } */
  }

  resetBgColor() {
    this.sharedService.getThemeColor().subscribe(
      data => {
        this.defaultColors = data;
        // data.filter(function(color, index){
          data.filter((color, index) =>{
          if(color.defaultColor == true){
            localStorage.setItem('themeColor', color.colorCode);
            localStorage.setItem('themeIndex', index);
            localStorage.setItem('themeName', 'index0');
            $('#confBar #themeContainer ul li.settingBtm input').removeClass('colorPaletteActive');
            $('#confBar #themeContainer ul li.settingBtm input:nth('+index+')').addClass('colorPaletteActive');

            // $('g > rect[stroke != "none"]').css('fill', color.colorCode); // for graph my rank
            this.sharedService.setBgColorData(color.colorCode);
          }
        })
      }, err => {

      })

  }

  fontminus() {

    this.plusBtn = false;
    this.num = this.num - 1;
    this.fn_changeFont(this.num);
    this.sharedService.currFontNum.next(this.num);
    if (this.num <= -3) {
      this.minusBtn = true;
      this.plusBtn = false;
    } else if (this.num > -3) {
      this.minusBtn = false;
      //this.plusBtn = true
    }
  }

  fontplus() {
    this.minusBtn = false;
    this.num = this.num + 1;
    this.fn_changeFont(this.num);
    this.sharedService.currFontNum.next(this.num);
    if (this.num >= 3) {
      this.plusBtn = true;
      this.minusBtn = false;
    } else if (this.num < 3) {
      this.plusBtn = false;
      //this.minusBtn = true
    }
  }

  fontreset() {
    this.minusBtn = false;
    this.plusBtn = false;
    this.num = 0;
    this.fn_changeFont(this.num);
    this.sharedService.currFontNum.next(this.num);
  }

  fn_changeFont(dynum) {
    $('.font-size-s').css('font-size', 14 + dynum + 'px');
    $('.font-size-m').css('font-size', 19 + dynum + 'px');
    $('.font-size-l').css('font-size', 23 + dynum + 'px');
    $('.mat-tab-label').css('font-size',14 + dynum + 'px');
    $('.no-styles').css('font-size',0.9 + dynum*0.1 + 'em');
    $('.mat-form-field-placeholder').css('font-size', 14 + dynum + 'px');
    $('.font-size-s > table td').css('font-size', 14 + dynum + 'px');
    $('.font-size-s > table th').css('font-size', 14 + dynum + 'px');
    this.sharedService.setFontSize(dynum);
  }

  onChange($event, deviceValue) {
    $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', deviceValue);
    localStorage.setItem('customFontType', deviceValue);
    this.sharedService.setFontType(deviceValue);
  }

  resetFontStyle() {
    this.sharedService.getThemeFont().subscribe(
      data => {
        this.defaultFonts = data;
        console.log('this.defaultFonts: ',this.defaultFonts);
        data.filter(function(font){
          if(font.defaultFont == true){

            $('#fontOptSideMenu2').val(font.fontName);
              $('body, .font-size-s, .font-size-m, .font-size-l, .font-size-xl, .font-size-xxl, .mat-tab-label, .mat-tab-link').css('font-family', font.fontName);
              $('.mat-select-value-text span').css('font-family', font.fontName);
              localStorage.setItem('customFontType', font.fontName);
          }
        })
      }, err => {

      })

      setTimeout(()=> {
        this.sharedService.loadFontTypeData();
      }, 100);
      setTimeout(()=> {
        this.sharedService.loadFontTypeData();
      }, 1000);
  }

  boolCallback = (result: boolean) : void => {
    this.loading = result;
  }

  clickFaq(){//29360
    //this.navService.triggerContent(29364, localStorage.getItem('langID'));
    //this.navService.getContentUrl(29364, localStorage.getItem('langID'));
    this.router.navigate(['/content', 29364], { queryParams: this.myflag });
    event.preventDefault();
  }

  clickManual(){
    //location.reload();
    //this.navService.triggerContent(15021, localStorage.getItem('langID'));
    //this.navService.getContentUrl(15021, localStorage.getItem('langID'));
    this.router.navigate(['/content', 15021], { queryParams: this.myflag });
    event.preventDefault();
  }

  clickAboutus(){
    //location.reload();26566
    //this.navService.triggerContent(15019, localStorage.getItem('langID'));
    //this.navService.getContentUrl(15019, localStorage.getItem('langID'));
    this.router.navigate(['/content', 15019], { queryParams: this.myflag });
    event.preventDefault();
  }

  clickGoHome(): void {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/header/topnav/topnav.component.ts